import { Page, Document, pdfjs } from 'react-pdf';
import { useState } from 'react';

const ShowPDF = ({pdfUrl}) => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [numPagesPDF, setNumPagesPDF] = useState(null);
    const [pageNumberPDF, setPageNumberPDF] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPagesPDF(numPages);
        setPageNumberPDF(1);
      }
  
      const handleNextPage = () => {
        if (pageNumberPDF < numPagesPDF) {
          setPageNumberPDF(pageNumberPDF + 1);
        }
      };
      
      const handlePreviousPage = () => {
        if (pageNumberPDF > 1) {
          setPageNumberPDF(pageNumberPDF - 1);
        }
      };


    return (
            <>
            <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess} className="overflow-x-auto overflow-y-auto h-4/5">
                                <Page pageNumber={pageNumberPDF} width={750} />
                              </Document>

                              {numPagesPDF && (
                                
                                <p>
                                  Page {pageNumberPDF} of {numPagesPDF}
                                </p>
                                
                                
                              )}
                              {
                                numPagesPDF > 1 && (
                                  <div className="flex">
                                    

                                    <button
                                    className="btn btn-sm btn-outline-dark px-2 text-light mr-3"
                                    style={{ backgroundColor: "#00213D" }}
                                    onClick={handlePreviousPage}
                                    >Previous Page
                                    </button>
                                    <button
                                    className="btn btn-sm btn-outline-dark px-2 text-light"
                                    style={{ backgroundColor: "#00213D" }}
                                    onClick={handleNextPage}
                                    >Next Page
                                    </button>
                                  </div>
                                )
                              }
            
            </>
            
    );



}


export default ShowPDF;